
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TaxGrid extends Serenity.EntityGrid<TaxRow, any> {
        protected getColumnsKey() { return 'OMS.Tax'; }
        protected getDialogType() { return TaxDialog; }
        protected getIdProperty() { return TaxRow.idProperty; }
        protected getInsertPermission() { return TaxRow.insertPermission; }
        protected getLocalTextPrefix() { return TaxRow.localTextPrefix; }
        protected getService() { return TaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}